/**
 * Converts time (in seconds) to display text.
 */
export const secondsToDisplayText = (seconds: number): string => {
    if (seconds < 60) {
        return `${seconds} second${seconds === 1 ? '' : 's'}`
    }

    const minutes = Math.floor(seconds / 60)
    const leftoverSeconds = seconds % 60
    let text = `${minutes} minute${minutes === 1 ? '' : 's'}`

    if (leftoverSeconds) {
        text += ` and ${leftoverSeconds} second${leftoverSeconds === 1 ? '' : 's'}`
    }

    return text
}

/**
 * Converts time (in seconds) to timestamp text.
 */
export const secondsToTimestamp = (seconds: number): string => {
    let ms = Math.floor((Math.floor((seconds * 1000) % 1000) / 1000) * 100)
    let s = Math.floor(seconds % 60)
    let m = Math.floor(((seconds * 1000) / (1000 * 60)) % 60)
    return 'M:SS.XX'
        .replace('M', `${m}`)
        .replace('SS', s < 10 ? `0${s}` : `${s}`)
        .replace('XX', ms < 10 ? `0${ms}` : `${ms}`)
}

/**
 * Converts file size (in megabytes) to display text.
 */
export const fileSizeToDisplayText = (megabytes: number): string => `${megabytes} megabyte${megabytes === 1 ? '' : 's'}`
